
import React from 'react';
import './App.css';

const Contact: React.FC = () => {
  return (
    <div className="page-container">
      <h2>Kontakt</h2>
      <p>Pro více informací nás kontaktujte na emailu: <a href="mailto:info@dobrezpravydnes.cz">info (@) dobrezpravydnes.cz</a></p>
    </div>
  );
};

export default Contact;